
// LOAD SCRIPTS AFTER PAGE FULLY LOADED

document.addEventListener('DOMContentLoaded', function () {
    /* Your code here */
    
        
    /*************************************************/
    /***********  Hamburger menu - Mobile  ***********/
    /*************************************************/

    var burger_icon = document.getElementById('burger-icon');
    var hamburger_menu_content = document.getElementById('hamburger-menu-content');
    var menu_close = document.getElementById('menu-close');

    var burger_location = document.getElementById('burger-location');
    var panel_location = document.getElementById('panel-location');
    var back_to_initial_from_location = document.getElementById('back-to-initial-from-location');
    var back_to_location = document.querySelectorAll('.back-to-location');

    var burger_achat = document.getElementById('burger-achat');
    var panel_achat = document.getElementById('panel-achat');
    var back_to_initial_from_achat = document.getElementById('back-to-initial-from-achat');
    var back_to_achat = document.querySelectorAll('.back-to-achat');

    var categories = document.querySelectorAll('.header-category');
    var panel_subcategory = document.querySelectorAll('.panel-subcategory');

    var burger_services = document.getElementById('burger-services');
    var panel_services = document.getElementById('panel-services');
    var back_to_initial_from_services = document.getElementById('back-to-initial-from-services');

    function initBurger(){
        hamburger_menu_content.classList.remove('visible');
        document.body.classList.remove('no-scroll');
        setTimeout(function() {
            panel_location.classList.remove('visible');
            panel_achat.classList.remove('visible');
            panel_subcategory.forEach(function(ps){
                ps.classList.remove('visible');
            });
            panel_services.classList.remove('visible');
        }, 800);  
    }

    initBurger();

    //Ouverture/fermeture du menu (niveau 1)
    burger_icon.addEventListener('click', function() {
        hamburger_menu_content.classList.add('visible');
        document.body.classList.add('no-scroll');
    });

    menu_close.addEventListener('click', function() {
        initBurger();
    });

    //Ouverture/fermeture du panneau des locations (niveau 2)
    burger_location.addEventListener('click', function() {
        panel_location.classList.add('visible');
    });

    back_to_initial_from_location.addEventListener('click', function() {
        panel_location.classList.remove('visible');
    });


    //Ouverture/fermeture du panneau des sous-locations (niveau 3)
    categories.forEach(function(allElements){
        allElements.addEventListener('click', function() {
            var corresponding_panel = document.getElementById('panel-' + allElements.dataset.id);         
            corresponding_panel.classList.add('visible');
        });
    });


    back_to_location.forEach(function(allElements){
        allElements.addEventListener('click', function() {
            panel_subcategory.forEach(function(ps){
                ps.classList.remove('visible');
            });
        });
    });


    //Ouverture/fermeture du panneau des achats (niveau 2)
    burger_achat.addEventListener('click', function() {
        panel_achat.classList.add('visible');
    });

    back_to_initial_from_achat.addEventListener('click', function() {
        panel_achat.classList.remove('visible');
    });

    back_to_achat.forEach(function(allElements){
        allElements.addEventListener('click', function() {
            panel_subcategory.forEach(function(ps){
                ps.classList.remove('visible');
            });
        });
    });

    //Ouverture/fermeture du panneau des services (niveau 2)
    burger_services.addEventListener('click', function() {
        panel_services.classList.add('visible');
    });

    back_to_initial_from_services.addEventListener('click', function() {
        panel_services.classList.remove('visible');
    });




    /*************************************************/
    /***********  Hamburger menu - Desktop  **********/
    /*************************************************/

    var desktop_menu_location = document.getElementById('desktop-menu-location');
    var desktop_menu_content = document.getElementById('desktop-menu-content');
    var desktop_menu_close = document.querySelectorAll('.desktop-menu-close'); 
    var desktop_categories = document.querySelectorAll('.desktop-header-category');
    var desktop_categories_location = document.querySelectorAll('.dhc-location');

    var desktop_panel_subcategories = document.querySelectorAll('.desktop-panel-subcategory');
    var desktop_panel_location = document.getElementById('desktop-panel-location');

    var desktop_menu_achat = document.getElementById('desktop-menu-achat');
    var desktop_panel_achat = document.getElementById('desktop-panel-achat');
    var desktop_categories_achat = document.querySelectorAll('.dhc-achat');

    var desktop_menu_services = document.getElementById('desktop-menu-services');
    var desktop_panel_services = document.getElementById('desktop-panel-services');

    var click_to_open_wide_menu = document.querySelectorAll('.click-to-open-wide-menu');
    var click_to_close_wide_menu = document.querySelectorAll('.click-to-close-wide-menu');

    var desktop_panel_search = document.querySelectorAll('.desktop-panel-search');
    var open_desktop_panel_search = document.querySelectorAll('.open-desktop-panel-search');
    var close_desktop_panel_search = document.getElementById('close-desktop-panel-search');
    var main = document.getElementById('main');
    var footer = document.getElementById('footer');


    let timeout = 0;

    function reinitMenuDesktop(){
        desktop_menu_content.classList.remove('visible');
        desktop_menu_location.classList.remove('active');
        desktop_menu_achat.classList.remove('active');
        desktop_menu_services.classList.remove('active');

        document.body.classList.remove('no-scroll');

        timeout = setTimeout(function() {
            desktop_menu_content.classList.remove('z-index');
            desktop_panel_location.classList.remove('active');
            desktop_panel_achat.classList.remove('active');
            desktop_panel_services.classList.remove('active');
            desktop_categories.forEach(function(all){
                all.classList.remove('active');
            });
        }, 600);
    }

    function open_wide_menu(){
        
        clearTimeout(timeout);

        //Faire disparaître un éventuel panneau de Recherche ouvert
        desktop_panel_search.forEach(function(allElements){
            allElements.classList.remove('open');
        });
        
        desktop_menu_content.classList.add('z-index');
        document.body.classList.add('no-scroll');
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setTimeout(function() {
            desktop_menu_content.classList.add('visible');
        }, 5);  
    }

    function open_onglet_location(){
        desktop_menu_location.classList.add('active');
        desktop_panel_location.classList.add('active');

        /* Gestion des catégories de location */
        desktop_categories[0].classList.add('active');
        desktop_panel_subcategories.forEach(function(allSubCategories){
            allSubCategories.classList.remove('visible');
        });

        /* Désactivation des autres onglets */
        desktop_menu_achat.classList.remove('active');
        desktop_panel_achat.classList.remove('active');
        desktop_menu_services.classList.remove('active');
        desktop_panel_services.classList.remove('active');

        /* Ouverture de la première sous-catégorie (par défaut) */
        setTimeout(function() {
            open_sub_categories(desktop_categories_location[0]);
        }, 5); 
    }

    function open_onglet_achat(){
        desktop_menu_achat.classList.add('active');
        desktop_panel_achat.classList.add('active');

        /* Gestion des catégories d'achat*/
        desktop_categories[0].classList.add('active');
        desktop_panel_subcategories.forEach(function(allSubCategories){
            allSubCategories.classList.remove('visible');
        });

        /* Désactivation des autres onglets */
        desktop_menu_location.classList.remove('active');
        desktop_panel_location.classList.remove('active');
        desktop_menu_services.classList.remove('active');
        desktop_panel_services.classList.remove('active');

        /* Ouverture de la première sous-catégorie (par défaut) */
        setTimeout(function() {
            open_sub_categories(desktop_categories_achat[0]);
        }, 5);  
    }

    function open_onglet_services(){
        desktop_menu_services.classList.add('active');
        desktop_panel_services.classList.add('active');

        /* Désactivation des autres onglets */
        desktop_menu_location.classList.remove('active');
        desktop_panel_location.classList.remove('active');
        desktop_menu_achat.classList.remove('active');
        desktop_panel_achat.classList.remove('active');

        desktop_categories[0].classList.remove('active');
        desktop_panel_subcategories.forEach(function(allSubCategories){
            allSubCategories.classList.remove('visible');
        });
    }

    function open_sub_categories(my_category){
        desktop_categories.forEach(function(all){
            all.classList.remove('active');
        });
        my_category.classList.add('active');

        desktop_panel_subcategories.forEach(function(allSubCategories){
            allSubCategories.classList.remove('visible');
        });
        var corresponding_panel_desktop = document.getElementById('desktop-panel-' + my_category.dataset.id);    
        if(document.body.contains(corresponding_panel_desktop)){
            corresponding_panel_desktop.classList.add('visible');
        }
    }

    //Initialisation (méga-menu fermé)
    reinitMenuDesktop();

    //Ouverture du méga-menu (niveau 1) au survol de la souris
    click_to_open_wide_menu.forEach(function(element){
        element.addEventListener('mouseenter', function() {
            if(!element.classList.contains('active')){
                open_wide_menu();
            }
        });
    });

    //Fermeture du méga-menu (niveau 1)
    click_to_close_wide_menu.forEach(function(element){
        element.addEventListener('mouseenter', function() {
            reinitMenuDesktop();
        });
    });

    //Onglet Location
    desktop_menu_location.addEventListener('mouseenter', function() {
        if(!desktop_menu_location.classList.contains('active')){
            open_onglet_location();
        }
    });

    //Onglet Achat
    desktop_menu_achat.addEventListener('mouseenter', function() {
        if(!desktop_menu_achat.classList.contains('active')){
            open_onglet_achat(); 
        }
    });

    //Onglet Services
    desktop_menu_services.addEventListener('mouseenter', function() {
        if(!desktop_menu_services.classList.contains('active')){
            open_onglet_services(); 
        }
    });



    desktop_menu_close.forEach(function(allElements){
        allElements.addEventListener('click', function() {
            reinitMenuDesktop();
        });
    });

    
    main.addEventListener('mouseenter', function() {
        reinitMenuDesktop();
    });
    footer.addEventListener('mouseenter', function() {
        reinitMenuDesktop();
    });

    //Ouverture du panneau des sous-locations (niveau 2)
    desktop_categories.forEach(function(allElements){
        allElements.addEventListener('mouseenter', function() {
            open_sub_categories(allElements);
        });
    });

    //Onglet Search (desktop)
    open_desktop_panel_search.forEach(function(allElements){
        allElements.addEventListener('click', function() {

            document.getElementById('visible-header').classList.add('active');

            desktop_panel_search.forEach(function(e){
                e.classList.add("open"); 

                var my_input = e.children[0].getElementsByTagName('input')[0];
                my_input.focus();

                document.body.classList.add('no-scroll');
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            });
        });
    });

    close_desktop_panel_search.addEventListener('click', function() {
        desktop_panel_search.forEach(function(e){
            e.classList.remove("open"); 
            document.body.classList.remove('no-scroll');
            document.getElementById('visible-header').classList.remove('active');
        });
    });

    main.addEventListener('click', function() {
        close_desktop_panel_search.click();
    });
    footer.addEventListener('click', function() {
        close_desktop_panel_search.click();
    });
    

    /*************************************************/
    /********************  AOS  **********************/
    /*************************************************/

    AOS.init({
        offset: 100
    });


    /*************************************************/
    /************  Adjust header height  *************/
    /*************************************************/

    function adjustHeaderHeight(){
        var header = document.getElementById('header');
        var main = document.getElementById('main');
        if(header && main){
            var headerHeightREM = header.offsetHeight/10;
            if(window.innerWidth < 768){
                main.style.marginTop = headerHeightREM + 'rem';
            } else {
                main.style.marginTop = 0;
            }
        }
    }

    adjustHeaderHeight();
    window.addEventListener('resize', adjustHeaderHeight);


    window.addEventListener('scroll', function() {
        if(window.innerWidth < 768){
            let scrollPosition = window.scrollY;
            if(scrollPosition > 0){
                document.querySelectorAll('.adjust').forEach(function(allElements){
                    allElements.classList.add('active');
                });        
            } else {
                document.querySelectorAll('.adjust').forEach(function(allElements){
                    allElements.classList.remove('active');
                });
            }
        } else {
            document.querySelectorAll('.adjust').forEach(function(allElements){
                allElements.classList.remove('active');
            });
        }
    });



    /* Swiper on single page */
    (function init_my_swiper(){
        const my_block = document.querySelector('.productSlider');
        if(document.body.contains(my_block)){
            var swiper = new Swiper(".productSlider", {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
            });
        }
    })();

})





/**********************************************************************/
/********************  custom-reveal-animation.js  ********************/
/**********************************************************************/


document.addEventListener("DOMContentLoaded", customRevealAnimationJS('-60px'));


/** 
 * Crée une animation lorsqu'on scrolle vers le bas de la page
 * 
 * @param {String} bottom_trigger_point
 * Seuil de déclenchement de l'animation à partir du bas du viewport (en % ou px)
 * -> par défaut, 15% de l'écran
 * 
 * @param {Number} intern_threshold
 * Seuil de déclenchement interne à l'élément (valeur comprise entre 0 et 1)
 * -> par défault, 0 : déclenchement dès qu'une partie de l'élément est dans le viewport
 * -> 1 : déclenchement lorsque 100% de l'élément est dans le viewport 
 */
function customRevealAnimationJS(bottom_trigger_point = '-15%', intern_threshold = 0){

    const animationItems = document.querySelectorAll('[data-reveal-trigger]');

    //Validation des paramètres
    if(!validateParameters(bottom_trigger_point, intern_threshold)){
        //Affichage de tous les éléments sans animation
        animationItems.forEach(function(item){
            item.setAttribute('data-reveal-trigger', 'visible');
        });
        return;
    }

    //Gestion de l'intersection
    let intersectionHandler = (entries) => {
        entries.forEach((entry) => {

            //Si l'élément est dans le viewport (visible)
            if (entry.isIntersecting){
                entry.target.setAttribute('data-reveal-trigger', 'visible');
                
                //Pour que l'animation ne fonctionne qu'une seule fois, décommenter la ligne suivante :
                //observer.unobserve(entry.target);
            }

            //Sinon, l'élément n'est pas dans le viewport (non visible)
            else {
                entry.target.setAttribute('data-reveal-trigger', 'not-visible');
            }

            //Mise à jour des délais
            addRevealDelay();

        });       
    }

    //Seuils de déclenchement
    let options = {
        rootMargin: '1000% 0px ' + bottom_trigger_point + ' 0px',
        threshold: intern_threshold
    };

    //Création de l'observateur
    let observer = new IntersectionObserver(intersectionHandler, options);

    //Mise sous observation
    animationItems.forEach(item => {
        observer.observe(item);      
    });

    //Mise à jour des délais
    addRevealDelay();

}


/** 
 * Validation des paramètres
 * @param {String} pixels_or_percentage_value Doit être une valeur négative en % ou en px, écrite dans une chaîne de caractères
 * @param {Number} floating_number Doit être un float compris en entre 0 et 1
 * @return {Boolean} Renvoie true si les paramètres sont corrects, false sinon
 */
 function validateParameters(pixels_or_percentage_value, floating_number){
    let regexPixels = /^-[0-9]+px$/i;
    let regexPercentage = /^-[0-9]+%$/i;
    let correctFormat = true;
    if(typeof(pixels_or_percentage_value) !== "string" || !(regexPixels.test(pixels_or_percentage_value) || regexPercentage.test(pixels_or_percentage_value))){
        console.error("customRevealAnimationJS() -> Initialisation error: first parameter must be a negative value in % or px. Example: '-10%' or '-15px' (written as a string)");
        correctFormat = false;
    }
    if(typeof(floating_number) !== "number" || floating_number < 0 || floating_number > 1){
        console.error("customRevealAnimationJS() -> Initialisation error: second parameter must be a floating number between 0.0 and 1.0. Example: 0.2");
        correctFormat = false;
    }
    return correctFormat;
}


/** 
 * Gestion des délais
 * -> Ajuste les délais d'animation de chaque élément contenant [data-reveal-delay]
 */
function addRevealDelay(){
    document.querySelectorAll('[data-reveal-delay]').forEach(item => {
        item.style.transitionDelay = item.dataset.revealDelay + 'ms';         
    });
}


// SimpleParallax
var images = document.querySelectorAll('.my-parallax');
new simpleParallax(images, {scale: 1.1});


// LIGHTHOUSE AUDIT

// Sometimes, you need to force Google Lighthouse Test to ignore something for better debugging. With this function you can load some styles that only Google Lighthouse will load.
/*if (navigator.userAgent.indexOf("Chrome-Lighthouse") > -1) { var sheet = window.document.styleSheets[0];
   sheet.insertRule('.section-title__bg{ color: black!important;}', sheet.cssRules.length);
}*/